import { render } from "./VideoCommentReply.vue?vue&type=template&id=03a12dd8"
import script from "./VideoCommentReply.vue?vue&type=script&lang=js"
export * from "./VideoCommentReply.vue?vue&type=script&lang=js"

import "./VideoCommentReply.vue?vue&type=style&index=0&id=03a12dd8&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__